






















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Card from '@/components/default/Card.vue';
import { DxTreeList, DxEditing, DxRowDragging, DxColumnFixing, DxStateStoring } from 'devextreme-vue/tree-list';
import { Article, IUsedArticle, MeasurementRoom, UsedArticle, MeasuringUnitsClient, MeasuringUnit } from '@/data/web-api-client';
import _ from 'lodash';

@Component({
  components: {
    Card,
    DxTreeList,
    DxEditing,
    DxRowDragging,
    DxColumnFixing,
    DxStateStoring,
  },
})
export default class MeasurementRoomCard extends Vue {
  @Prop({ required: true })
  autoInsert!: boolean;

  @Prop({ required: true })
  room!: MeasurementRoom;

  @Prop({ required: true })
  allowedArticles!: Article[];

  @Prop({ required: true })
  previousArticleId!: string;

  @Prop({ required: false, default: false })
  disabled!: boolean;

  repaint: boolean = false;
  parentRecordId: string | null = null;

  removeRoom() {
    this.$emit('remove');
  }
  changeRoomName() {
    this.$emit('changeName');
  }
  duplicateRoom() {
    this.$emit('duplicate');
  }

  getGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      // tslint:disable-next-line
      const r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  rowInserting(e: any) {
    const data = e.data as IUsedArticle;
    data.lineId = this.getGuid();
    this.room.usedArticles!.unshift(new UsedArticle(data));
    const instance = (this.$refs.treelist as any).instance;
    if (instance) {
      instance.cancelEditData();
    }

    this.$emit('setPreviousArticleId', e.data.articleId);

    e.cancel = true;
    this.rowInserted();
  }

  rowUpdated(e: any) {
    this.$emit('setPreviousArticleId', e.data.articleId);

    this.updated();
  }

  rowDeleted(e: any) {
    this.deleteWithParentId(e.data.lineId);
    this.updated();
  }

  deleteWithParentId(parentId: string) {
    if (!this.room.usedArticles) {
      return;
    }

    const deletedIds: string[] = [];
    for (let i = this.room.usedArticles!.length - 1; i >= 0; i--) {
      const usedArticle = this.room.usedArticles[i];
      if (usedArticle.parentLineId === parentId) {
        deletedIds.push(usedArticle.lineId!);
        this.room.usedArticles.splice(i, 1);
      }
    }

    deletedIds.forEach((id) => {
      this.deleteWithParentId(id);
    });
  }

  addRow(parentId: string | null) {
    this.parentRecordId = parentId;
    (this.$refs.treelist as any).instance!.addRow(parentId);
  }

  rowInserted() {
    setTimeout(() => {
      if (this.autoInsert) {
        this.addRow(this.parentRecordId);
      }
    }, 200);
  }

  updated() {
    this.displayMeasuringUnits();
    this.$emit('save');
  }

  setTextColorDeduction(e: any) {
    if (e.rowType === 'data') {
      if (e.data.deduction && e.value < 0) {
        $(e.cellElement).addClass('text-danger');
      }
    }
  }

  initRow(e: any) {
    if (this.previousArticleId && this.previousArticleId !== '') {
      e.data.articleId = this.previousArticleId;
    }

    if (this.parentRecordId && this.parentRecordId !== null) {
      try {
        const node = e.component.getNodeByKey(this.parentRecordId);
        if (node && node !== null) {
          e.data.amount = node.data.amount;
          e.data.deduction = node.data.deduction;
          e.data.height = node.data.height;
          e.data.length = node.data.length;
        }
      } catch {
        // do nothing
      }
      e.data.parentLineId = this.parentRecordId;
    }
  }

  calculateAmountFromLine(usedArticle: IUsedArticle): number {
    let amount = 0; // Calculate total amount amount * height * length
    if (usedArticle.length) {
      amount += usedArticle.length;
    }
    if (usedArticle.height) {
      if (amount === 0) {
        amount += usedArticle.height;
      } else {
        amount *= usedArticle.height;
      }
    }
    if (usedArticle.amount) {
      if (amount === 0) {
        amount += usedArticle.amount;
      } else {
        amount *= usedArticle.amount;
      }
    }
    if (usedArticle.deduction) {
      amount = 0 - amount;
    }

    return amount;
  }

  onReorderLine(e: any) {
    const visibleRows = e.component.getVisibleRows();
    const sourceData = e.itemData;
    const targetData = visibleRows[e.toIndex].data;

    if(sourceData.lineId == targetData.parentLineId){
      // User tried to drag a parent line in one of its child lines.
      // Not allowed
      return;
    }

    if (e.dropInsideItem) {
      e.itemData.parentLineId = targetData.lineId;
      e.component.refresh();
    } else {
      const sourceIndex = this.room.usedArticles!.indexOf(sourceData);
      let targetIndex = this.room.usedArticles!.indexOf(targetData);

      if (sourceData.parentLineId !== targetData.parentLineId) {
        sourceData.parentLineId = targetData.parentLineId;
        if (e.toIndex > e.fromIndex) {
          targetIndex++;
        }
      }

      this.room.usedArticles!.splice(sourceIndex, 1);
      this.room.usedArticles!.splice(targetIndex, 0, sourceData);
    }
  }

  copyRow(e: any) {
    const index = this.room.usedArticles!.findIndex((o: UsedArticle) => o.lineId === e.row.data.lineId);
    if (index !== -1) {
      const objData: IUsedArticle = _.cloneDeep(e.row.data);
      objData.lineId = this.getGuid();
      this.room.usedArticles!.splice(index, 0, new UsedArticle(objData));
      this.duplicateChildLines(e.row.data.lineId, objData.lineId);
    }
  }

  duplicateChildLines(oldParentId: string, newParentId: string) {
    const foundItems = this.room.usedArticles!.filter((o: UsedArticle) => o.parentLineId === oldParentId);
    foundItems.forEach((foundItem: UsedArticle) => {
      const objData: IUsedArticle = _.cloneDeep(foundItem);
      const oldId = '' + objData.lineId;
      objData.lineId = this.getGuid();
      objData.parentLineId = newParentId;
      this.room.usedArticles!.push(new UsedArticle(objData));
      this.duplicateChildLines(oldId, objData.lineId);
    });
  }

  setMeasuringUnit(articleId: string) {
    const article = this.allowedArticles.find((a: any) => a.id == articleId);

    if (!article) {
      return;
    }

    const instance = (this.$refs.treelist as DxTreeList).instance;

    if (!instance) {
      return;
    }

    const row = instance.getVisibleRows().find((r) => r.isEditing);

    if (!row) {
      return;
    }

    instance.cellValue(row.rowIndex!, 'measuringUnit', article.measuringUnit);
    instance.repaint();
  }

  get columns() {
    const self = this;
    const columns: any[] = [
      {
        dataField: 'articleId',
        caption: 'Code',
        lookup: {
          dataSource: this.allowedArticles,
          displayExpr(val: any) {
            return val.description ? `${val.name}: ${val.description}` : val.name;
          },
          allowClearing: true,
          valueExpr: 'id',
        },
        validationRules: [{ type: 'required', message: 'Code is verplicht' }],
        onEditorPreparing: {
          onValueChanged: (e: any) => {
            this.setMeasuringUnit(e.value);

            return e.value;

            // return this.allowedArticles.find((aa: Article) => {
            //   aa.id == e.value;
            // });
          },
        },
      },
      {
        dataField: 'measuringUnit',
        caption: 'Meeteenh.',
        calculateDisplayValue(value: UsedArticle) {
          return value.measuringUnit;
        },
        // lookup: {
        //   dataSource: this.measuringUnits,
        //   allowClearing: true,
        //   valueExpr(val: string) {
        //     return val;
        //   },
        //   displayExpr(val: string) {
        //     return val;
        //   },
        // },
      },
      {
        dataField: 'deduction',
        caption: this.$t('objects.measurements.Deduction'),
        dataType: 'boolean',
      },
      {
        dataField: 'amount',
        caption: this.$t('objects.measurements.Quantity'),
        dataType: 'number',
        alignment: 'left',
      },
      {
        dataField: 'length',
        caption: this.$t('objects.measurements.Length'),
        dataType: 'number',
        alignment: 'left',
        format: {
          type: 'fixedPoint',
          precision: 2,
        },
      },
      {
        dataField: 'height',
        caption: this.$t('objects.measurements.Height'),
        dataType: 'number',
        alignment: 'left',
        format: {
          type: 'fixedPoint',
          precision: 2,
        },
      },
      {
        alignment: 'left',
        formItem: {
          visible: false,
        },
        caption: this.$t('objects.measurements.Total'),
        cssClass: '',
        calculateCellValue(value: any) {
          return self.calculateAmountFromLine(value);
        },
        calculateDisplayValue(value: any) {
          let result = self.calculateAmountFromLine(value);
          result = Math.round(result * 100) / 100;
          return value.article ? result + ' ' + value.article.measuringUnit : result;
        },
      },
      {
        dataField: 'notes',
        caption: this.$t('objects.measurements.Notes'),
        dataType: 'text',
      }
    ];

    if (!this.disabled) {
      columns.push({
        type: 'buttons',
        buttons: [
          {
            hint: 'Toevoegen',
            icon: 'fas fa-plus',
            visible(e: any) {
              return !e.row.isEditing && !e.row.data.isCompleted && !self.disabled;
            },
            onClick: (e: any) => {
              this.parentRecordId = e.row.data.lineId;
              setTimeout(() => {
                // e.component.addRow(this.parentRecordId);
                const node = e.component.getNodeByKey(this.parentRecordId);

                this.room.usedArticles!.push(
                  new UsedArticle({
                    amount: node.data.amount,
                    parentLineId: e.row.data.lineId,
                    lineId: this.getGuid(),
                    articleId: this.previousArticleId && this.previousArticleId !== '' ? this.previousArticleId : node.data.articleId,
                    deduction: node.data.deduction,
                    length: node.data.length,
                    height: node.data.height,
                  })
                );

                /*if (this.previousArticleId && this.previousArticleId !== '') {
                            e.data.articleId = this.previousArticleId;
                        }

                        if (this.parentRecordId && this.parentRecordId !== null) {
                            try {
                                const node = e.component.getNodeByKey(this.parentRecordId);
                                if (node && node !== null) {
                                    e.data.amount = node.data.amount;
                                    e.data.deduction = node.data.deduction;
                                    e.data.height = node.data.height;
                                    e.data.length = node.data.length;
                                }
                            } catch {
                                // do nothing
                            }
                            e.data.parentLineId = this.parentRecordId;
                        }*/
              }, 200);
            },
          },
          {
            hint: 'Kopie nemen',
            icon: 'fas fa-copy',
            visible(e: any) {
              return !e.row.isEditing && !e.row.data.isCompleted && !self.disabled;
            },
            onClick: this.copyRow,
          },
          'edit',
          'delete'
        ],
      });

      return columns;
    }
  }

  displayMeasuringUnits() {
    if (this.room.usedArticles != undefined) {
      this.room.usedArticles.forEach((usedArticle: UsedArticle) => {
        const matchingArticle = this.allowedArticles.find((aa: Article) => aa.id == usedArticle.articleId);

        if (matchingArticle == null) {
          return;
        }

        usedArticle.measuringUnit = matchingArticle.measuringUnit;
      });
    }
  }

  @Watch('allowedArticles', { deep: true })
  onArticlesChanged() {
    this.repaint = true;
    this.displayMeasuringUnits();
    setTimeout(() => {
      this.repaint = false;
    }, 500);
  }
}
